'use strict'
const merge = require('webpack-merge')
module.exports = merge({
  CLIENT_ID: '713322577537-fuii363ubj7d9n9u5vhdtmlpnp8ufjhp.apps.googleusercontent.com'
})